import Slider from '@material-ui/core/Slider';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles
} from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    filters: {
      width: '220px',
      padding: theme.spacing(2),
      border: '1px solid #f0f0f0',
      backgroundColor: '#fcfcfc',
      borderRadius: '13px',
      [theme.breakpoints.down(480)]: {
        width: '100%'
      },
    },
    brandsFilter: {
      marginBottom: '20px',
    },
    filterTitle: {
      fontWeight: 'bold',
      color: '#0047BA',
      fontSize: '14px',
    },
    filterInput: {
      maxWidth: '65px',
      '&>.MuiInputBase-root': {
        height: '30px',
        width: '65px',
        borderRadius: '17px',
      },
      '&>.MuiInputBase-root>input': {
        textAlign: 'center',
      },
    },

    brandsBox: {
      width: '100%',
      height: '100px',
      padding: '2px',
      marginBottom: '50px',
    },
    checkboxFields: {
      maxWidth: '100%',
      width: '34px',
    },
    buttonFilters: {
      padding: '6px 24px',
      marginRight: '16px',
      backgroundColor: '#0047BA',
      borderRadius: '50px',
      border: '1px solid #646464',
      color: '#fff',
      fontWeight: 'bold',
      cursor: 'pointer',
      outline: 0,
    }
  })
);

export const StyledSlider = withStyles({
  root: {
    color: '#0047BA',
    height: '8px',
    maxWidth: '150px',
  },
  track: {
    height: '6px',
    borderRadius: '4px',
    maxWidth: '150px',
  },
  rail: {
    height: '6px',
    borderRadius: '4px',
    maxWidth: '150px',
  },
  thumb: {
    height: '15px',
    width: '15px',
  },
})(Slider);

export default useStyles;
